import React from "react"
import { useDroppable } from "@dnd-kit/react"
import { CollisionPriority } from "@dnd-kit/abstract"
import CatchCard from "~/library/CatchCard"
import AccordionSection from "~/library/UIkit/AccordionSection"
import DraggableTask from "./DraggableTask"
import { Task } from "~/types/sponsorship/Task"

interface DroppableStatusSectionProps {
  status: string
  statusLabel: string
  tasks: Task[]
  isExpanded: boolean
  onToggle: () => void
  onDeleteTask: (taskId: string) => void
  onTaskUpdated?: () => void
}

const DroppableStatusSection: React.FC<DroppableStatusSectionProps> = ({
  status,
  statusLabel,
  tasks,
  isExpanded,
  onToggle,
  onDeleteTask,
  onTaskUpdated,
}) => {
  const { ref } = useDroppable({
    id: status,
    type: "status",
    accept: "task",
    disabled: !isExpanded,
    collisionPriority: CollisionPriority.Low,
  })

  const cardStyle: React.CSSProperties = {
    marginBottom: "1rem",
  }

  return (
    <CatchCard style={cardStyle} bodyClassName="card-body-p-1">
      <AccordionSection title={statusLabel} isExpanded={isExpanded} onToggle={onToggle}>
        <div ref={ref}>
          {tasks.length > 0 ? (
            <div className="mt-2 mb-2">
              {tasks.map((task, index) => (
                <DraggableTask
                  key={task.id}
                  task={task}
                  index={index}
                  status={status}
                  onDeleteTask={onDeleteTask}
                  onTaskUpdated={onTaskUpdated}
                />
              ))}
            </div>
          ) : (
            <div className="text-center py-4">
              <p className="text-muted mb-0">Drag&amp;Drop tasks here or Create one</p>
            </div>
          )}
        </div>
      </AccordionSection>
    </CatchCard>
  )
}

export default DroppableStatusSection
